<template>
  <div class="cascader">
    <el-cascader
      :size="size"
      v-model="value1"
      :disabled="disabled"
      :options="citys"
      :props="cascaderProps"
      @change="handleChange"
    />
  </div>
</template>

<script>
// import { regionData } from "element-china-area-data";
import { regionData } from "@/lib/citys.js";
export default {
  name: "cascader",
  props: {
    cascaderProps: {
      type: Object,
      default: () => {
        return { value: "label" };
      },
    },
    value: {
      type: Array,
      default: () => [],
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    size: {
      default: "small",
    },
  },
  // watch: {
  //   'value': {
  //     handler(val) {
  //       console.log(val);
  //     },
  //     deep: true,
  //     immediate: true,
  //   }
  // },
  data() {
    return {
      citys: regionData,
      value1: "",
    };
  },
  methods: {
    // 城市联动，通过emit返回选择的数据返回给父级
    handleChange(val) {
      // val 返回的是中文数组['省', '市', '区']
      this.$emit("input", val);
    },
  },
  mounted() {
    this.value1 = this.value;
  },
};
</script>

<style lang="scss" scoped>
.cascader {
  ::v-deep {
    .el-cascader {
      width: 100%;
      // line-height: 32px;
    }
    // .el-input__inner {
    //   height: 32px !important;
    //   line-height: 32px !important;
    // }
    // .el-input--small {
    //   .el-input__inner {
    //     height: 32px !important;
    //     line-height: 32px !important;
    //   }
    // }
  }
}
</style>
